import {setCookie} from "./fun_cookie";

export function error(fun, text){
    if(text.error_code===1003){
        setCookie('token','');
        window.location.reload();
    }
}